export const CONFIRMED_GET_KARMAS = "CONFIRMED_GET_KARMAS";
export const CONFIRMED_CREATE_KARMA_ACTION = "CONFIRMED_CREATE_KARMA_ACTION";
export const CONFIRMED_EDIT_KARMA_ACTION = "CONFIRMED_EDIT_KARMA_ACTION";
export const CONFIRMED_DELETE_KARMA_ACTION = "CONFIRMED_DELETE_KARMA_ACTION";